import {equipoConstants, userConstants} from '../_constants';

const userStoraged = localStorage.getItem("userLogged");
let user = userStoraged ? JSON.parse(userStoraged) : undefined;
let userData = user;
const initialState = user ? {user, userData} : {};

export function authentication(state = initialState, action) {
    switch (action.type) {
        case userConstants.LOGIN_REQUEST:
            return {
                ...state,
                loggingIn: true,
                user: action.user
            };
        case userConstants.LOGIN_SUCCESS:
            return {
                ...state,
                user: action.user,
                equipoNuevo: {idEquipoNuevo: action.idEquipoNuevo, esEquipoNuevo: action.esEquipoNuevo}
            };
        case userConstants.INFO_GENERAL_PERFIL:
            return {
                ...state,
                codigosPais: action.data.listados.codigosPais
            };


        case userConstants.GETLOGUEADO_SUCCESS:
            return {
                ...state,
                user: action.user,
                userData: action.user
            };
        case userConstants.LOGIN_FAILURE:
            return {};
        case userConstants.LOGOUT:
            return {};
        case equipoConstants.EQUIPO_LIMPIAR_EQUIPO_NUEVO_SUCCESS:
            return {
                ...state,
                equipoNuevo: {idEquipoNuevo: '', esEquipoNuevo: false}
            };

        case userConstants.LOGOUT:
            return {};
        default:
            return state
    }
}